import { OdgEvaluationNote } from '../models/odg.model';
import { SmileyBase } from './smiley-base';
import { Component, Input, Output,EventEmitter } from '@angular/core'


@Component({
    selector: 'odg-smiley-pc',
    template: `
    <div (click)="onSmileyClick()" class="smiley-img eval-pc" [ngClass]="{'active': isActive, 'unselected' : isUnselected, 'readonly': readonly}">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 15H16M15 9H15.01M9 9H9.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5 9C15.5 9.27614 15.2761 9.5 15 9.5C14.7239 9.5 14.5 9.27614 14.5 9C14.5 8.72386 14.7239 8.5 15 8.5C15.2761 8.5 15.5 8.72386 15.5 9ZM9.5 9C9.5 9.27614 9.27614 9.5 9 9.5C8.72386 9.5 8.5 9.27614 8.5 9C8.5 8.72386 8.72386 8.5 9 8.5C9.27614 8.5 9.5 8.72386 9.5 9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    `,
    styleUrls: ['./smiley.component.scss']
})
export class OdgSmileyPasConsommeComponent extends SmileyBase {
    @Input()
    activeNote: OdgEvaluationNote;
    @Input()
    readonly: boolean = false;
    @Output()
    smileyClick: EventEmitter<OdgEvaluationNote> = new EventEmitter<OdgEvaluationNote>();

    note: OdgEvaluationNote = OdgEvaluationNote.PasConsomme;
}
